export interface Anime {
  id: string;
  title: string;
  jpTitle: string;
  category: "healing" | "slice" | "cute" | "warm";
  year: string;
  studio: string;
  episodes: string;
  score: string;
  mood: string[];
  desc: string;
  image: string;
}

export const categoryMeta: Record<
  Anime["category"],
  { label: string; desc: string; icon: string }
> = {
  healing: {
    label: "治愈番",
    desc: "看完心里暖暖的，适合睡前放松",
    icon: "ri-heart-3-line",
  },
  slice: {
    label: "日常系",
    desc: "慢节奏生活流，下饭伴侣",
    icon: "ri-cup-line",
  },
  cute: {
    label: "萌系动画",
    desc: "软萌画风，治愈力拉满",
    icon: "ri-bear-smile-line",
  },
  warm: {
    label: "温馨番单",
    desc: "温暖人情味，越看越安心",
    icon: "ri-sun-line",
  },
};

export const animeList: Anime[] = [
  {
    id: "natsume",
    title: "夏目友人帐",
    jpTitle: "夏目友人帳",
    category: "healing",
    year: "2024",
    studio: "朱夏",
    episodes: "共7季",
    score: "9.6",
    mood: ["温柔", "妖怪", "治愈"],
    desc: "能看见妖怪的少年夏目，继承了祖母的友人帐，与猫老师一起把名字还给妖怪们。一段段或温暖或遗憾的故事，把孤独与陪伴讲得恰到好处。",
    image: "https://readdy.ai/api/search-image?query=warm%20soft%20watercolor%20anime%20illustration%20of%20a%20green%20field%20at%20sunset%20with%20a%20young%20boy%20and%20a%20round%20white%20and%20cream%20cat%20companion%2C%20floating%20fireflies%2C%20pastel%20green%20and%20amber%20tones%2C%20gentle%20healing%20atmosphere%2C%20clean%20minimalist%20style&width=800&height=600&seq=natsume-01&orientation=landscape",
  },
  {
    id: "nonbiri",
    title: "悠哉日常大王",
    jpTitle: "のんのんびより",
    category: "slice",
    year: "2023",
    studio: "SILVER LINK",
    episodes: "共3季",
    score: "9.4",
    mood: ["乡村", "悠闲", "夏日"],
    desc: "五个小女孩在乡下旭丘分校的日常。蝉鸣、稻田、放学路上的夕阳……没有惊天动地，只有平凡日子里的微小幸福，是日常系的天花板。",
    image: "https://readdy.ai/api/search-image?query=soft%20anime%20illustration%20of%20a%20sunny%20countryside%20road%20with%20green%20rice%20fields%2C%20school%20backpacks%20and%20a%20water%20tower%20in%20the%20distance%2C%20blue%20sky%20with%20white%20clouds%2C%20peaceful%20summer%20village%2C%20warm%20bright%20pastel%20colors%2C%20heartwarming%20slice%20of%20life&width=800&height=600&seq=nonbiri-02&orientation=landscape",
  },
  {
    id: "laidback",
    title: "摇曳露营△",
    jpTitle: "ゆるキャン△",
    category: "slice",
    year: "2023",
    studio: "C-Station",
    episodes: "共3季",
    score: "9.5",
    mood: ["露营", "风景", "放松"],
    desc: "独自露营的女孩凛，和热衷露营社团的抚子，一起看遍富士山的四季。从搭帐篷到煮咖喱锅，每一帧风景都能治愈疲惫的心。",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20campsite%20at%20dusk%20by%20a%20lake%20with%20mount%20fuji%20in%20the%20background%2C%20small%20tent%20with%20warm%20lantern%20light%2C%20campfire%20and%20steaming%20pot%2C%20purple%20and%20orange%20twilight%20sky%2C%20cozy%20peaceful%20atmosphere%2C%20soft%20pastel%20colors&width=800&height=600&seq=laidback-03&orientation=landscape",
  },
  {
    id: "gochiusa",
    title: "请问您今天要来点兔子吗",
    jpTitle: "ご注文はうさぎですか",
    category: "cute",
    year: "2020",
    studio: "WHITE FOX",
    episodes: "共3季",
    score: "9.2",
    mood: ["咖啡", "软萌", "治愈"],
    desc: "追梦咖啡师的女孩心爱，来到小镇上的Rabbit House。在咖啡香和可爱同伴的包围里，一段段萌系日常就此展开，看完满血复活。",
    image: "https://readdy.ai/api/search-image?query=cute%20anime%20illustration%20of%20a%20cozy%20pastel%20cafe%20with%20white%20rabbit%20ears%20girl%20serving%20coffee%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20cakes%20and%20cupcakes%20on%20counter%2C%20warm%20gentle%20lighting%2C%20adorable%20healing%20moe%20style&width=800&height=600&seq=gochiusa-04&orientation=landscape",
  },
  {
    id: "spyfamily",
    title: "间谍过家家",
    jpTitle: "SPY×FAMILY",
    category: "warm",
    year: "2024",
    studio: "WIT STUDIO",
    episodes: "共3季",
    score: "9.3",
    mood: ["家庭", "搞笑", "温馨"],
    desc: "间谍、杀手与读心女孩组成的临时家庭，为了各自的秘密互相隐瞒，却意外成为彼此最温暖的依靠。笑中带泪的家庭温情番。",
    image: "https://readdy.ai/api/search-image?query=charming%20anime%20illustration%20of%20a%20happy%20family%20of%20three%20with%20a%20father%20mother%20and%20little%20girl%20with%20pink%20hair%2C%20warm%20yellow%20and%20peach%20tones%2C%20simple%20clean%20background%2C%20cozy%20hearty%20atmosphere%2C%20modern%20flat%20style&width=800&height=600&seq=spyfamily-05&orientation=landscape",
  },
  {
    id: "tamako",
    title: "玉子市场",
    jpTitle: "たまこまーけっと",
    category: "cute",
    year: "2013",
    studio: "京都动画",
    episodes: "共1季",
    score: "9.1",
    mood: ["年糕", "商店街", "青春"],
    desc: "商店街年糕店家的女儿玉子，在邻里充满人情味的日常里慢慢成长。京都动画的招牌治愈作，市井烟火气十足，暖到心坎里。",
    image: "https://readdy.ai/api/search-image?query=soft%20anime%20illustration%20of%20a%20traditional%20japanese%20shopping%20street%20with%20a%20girl%20carrying%20mochi%20rice%20cake%20trays%2C%20warm%20evening%20lantern%20lights%2C%20pastel%20cream%20and%20pink%20tones%2C%20cozy%20neighborhood%20vibes%2C%20heartwarming%20slice%20of%20life&width=800&height=600&seq=tamako-06&orientation=landscape",
  },
  {
    id: "takagi",
    title: "擅长捉弄的高木同学",
    jpTitle: "からかい上手の高木さん",
    category: "warm",
    year: "2022",
    studio: "SHIN-EI",
    episodes: "共2季",
    score: "9.2",
    mood: ["校园", "甜恋", "心动"],
    desc: "同桌的高木总爱捉弄西片，而西片总想着反杀却每次都落空。教室里的青涩日常，淡淡的甜和暖暖的心动，看了会不自觉上扬嘴角。",
    image: "https://readdy.ai/api/search-image?query=cute%20anime%20illustration%20of%20two%20middle%20school%20students%20at%20school%20desks%2C%20girl%20teasing%20blushing%20boy%2C%20warm%20golden%20classroom%20light%2C%20pastel%20pink%20and%20cream%20tones%2C%20sweet%20romantic%20youthful%20atmosphere%2C%20soft%20clean%20style&width=800&height=600&seq=takagi-07&orientation=landscape",
  },
  {
    id: "hidamari",
    title: "向阳素描",
    jpTitle: "ひだまりスケッチ",
    category: "cute",
    year: "2012",
    studio: "SHAFT",
    episodes: "共4季",
    score: "9.0",
    mood: ["美术", "宿舍", "治愈"],
    desc: "美术高中的少女们住在「向阳庄」的日常。画画、放学、一起吃火锅，细碎的片段拼成最温柔的高中生活，疲惫时看看很放松。",
    image: "https://readdy.ai/api/search-image?query=soft%20anime%20illustration%20of%20girls%20in%20an%20art%20studio%20with%20easels%20and%20sunny%20window%20light%2C%20painting%20on%20canvas%2C%20warm%20yellow%20and%20cream%20palette%2C%20cozy%20dorm%20room%20vibe%2C%20gentle%20healing%20moe%20style%2C%20clean%20background&width=800&height=600&seq=hidamari-08&orientation=landscape",
  },
  {
    id: "kobayashi",
    title: "小林家的龙女仆",
    jpTitle: "小林さんちのメイドラゴン",
    category: "cute",
    year: "2022",
    studio: "京都动画",
    episodes: "共2季",
    score: "9.1",
    mood: ["龙娘", "日常", "欢笑"],
    desc: "喝醉的小林把一只龙女仆托尔带回了家。人龙混居的爆笑日常里，藏着跨越种族的理解与温暖，是京都动画的招牌治愈作。",
    image: "https://readdy.ai/api/search-image?query=fun%20anime%20illustration%20of%20a%20small%20girl%20with%20tiny%20wings%20and%20horns%20in%20a%20maid%20outfit%20eating%20with%20a%20young%20office%20woman%2C%20warm%20homey%20living%20room%2C%20pastel%20green%20and%20peach%20tones%2C%20playful%20cozy%20atmosphere%2C%20cute%20modern%20style&width=800&height=600&seq=kobayashi-09&orientation=landscape",
  },
  {
    id: "march",
    title: "三月的狮子",
    jpTitle: "3月のライオン",
    category: "healing",
    year: "2017",
    studio: "SHAFT",
    episodes: "共2季",
    score: "9.5",
    mood: ["将棋", "成长", "治愈"],
    desc: "职业将棋手桐山零独自生活，直到遇见川本家三姐妹。那些关于孤独、伤痛与救赎的故事，看得人眼眶发热，却也被深深治愈。",
    image: "https://readdy.ai/api/search-image?query=contemplative%20anime%20illustration%20of%20a%20lonely%20young%20man%20by%20a%20window%20watching%20cherry%20blossoms%20fall%2C%20three%20sisters%20silhouette%20in%20the%20warm%20light%2C%20muted%20amber%20and%20cream%20tones%2C%20emotional%20heartwarming%20atmosphere%2C%20artistic%20painting%20style&width=800&height=600&seq=march-10&orientation=landscape",
  },
  {
    id: "k-on",
    title: "轻音少女",
    jpTitle: "けいおん！",
    category: "slice",
    year: "2011",
    studio: "京都动画",
    episodes: "共2季",
    score: "9.3",
    mood: ["音乐", "社团", "青春"],
    desc: "放学后的轻音部，四个（后来五个）女孩喝着红茶玩着乐队。没有宏大目标，只有放课后的美好时光，堪称日常番的元祖经典。",
    image: "https://readdy.ai/api/search-image?query=cheerful%20anime%20illustration%20of%20four%20high%20school%20girls%20playing%20guitar%20and%20drums%20in%20a%20bright%20school%20club%20room%2C%20guitars%20and%20teacups%20on%20desk%2C%20warm%20afternoon%20sunlight%2C%20pastel%20cream%20and%20pink%20tones%2C%20lively%20cozy%20slice%20of%20life&width=800&height=600&seq=kon-11&orientation=landscape",
  },
  {
    id: "kemono",
    title: "兽娘动物园",
    jpTitle: "けものフレンズ",
    category: "cute",
    year: "2017",
    studio: "ヤオヨロズ",
    episodes: "共1季",
    score: "8.9",
    mood: ["兽娘", "冒险", "纯净"],
    desc: "失去记忆的小包酱和薮猫酱在加帕里公园一起冒险。这部作品用最质朴的方式讲友谊与陪伴，纯净到让人找回复杂世界丢失的简单快乐。",
    image: "https://readdy.ai/api/search-image?query=adorable%20anime%20illustration%20of%20anthropomorphic%20animal%20girls%20on%20a%20sunny%20savanna%20adventure%2C%20a%20serval%20cat%20girl%20and%20small%20brown%20hare%20girl%2C%20bright%20green%20grassland%2C%20warm%20golden%20light%2C%20playful%20innocent%20moe%20style%2C%20clean%20vibrant%20colors&width=800&height=600&seq=kemono-12&orientation=landscape",
  },
];

export const watchlist = [
  {
    day: "周一到周三",
    title: "睡前放松款",
    picks: ["夏目友人帐", "向阳素描", "三月的狮子"],
    note: "节奏舒缓、适合临睡前慢慢看",
    image: "https://readdy.ai/api/search-image?query=cozy%20anime%20bedroom%20scene%20with%20warm%20night%20lamp%2C%20starry%20sky%20through%20window%2C%20soft%20cream%20and%20lavender%20blankets%2C%20peaceful%20sleepy%20healing%20atmosphere%2C%20soft%20pastel%20illustration&width=400&height=300&seq=wl-night-13&orientation=landscape",
  },
  {
    day: "周四到周五",
    title: "下饭欢乐款",
    picks: ["小林家的龙女仆", "间谍过家家", "请问您今天要来点兔子吗"],
    note: "轻快搞笑，吃饭摸鱼两不误",
    image: "https://readdy.ai/api/search-image?query=cheerful%20anime%20lunch%20scene%20with%20cute%20bento%20boxes%20and%20laughing%20characters%2C%20warm%20yellow%20and%20peach%20palette%2C%20playful%20cozy%20dining%20table%2C%20happy%20comfortable%20atmosphere%2C%20soft%20clean%20illustration&width=400&height=300&seq=wl-food-14&orientation=landscape",
  },
  {
    day: "周末",
    title: "深度治愈款",
    picks: ["悠哉日常大王", "摇曳露营△", "轻音少女"],
    note: "留一个下午，慢慢沉浸其中",
    image: "https://readdy.ai/api/search-image?query=relaxing%20weekend%20anime%20scene%20of%20girls%20enjoying%20tea%20and%20camping%20outdoors%2C%20warm%20afternoon%20sunlight%2C%20green%20hill%20and%20tent%2C%20cozy%20slow%20life%20vibes%2C%20soft%20pastel%20cream%20and%20green%20tones%2C%20peaceful%20illustration&width=400&height=300&seq=wl-weekend-15&orientation=landscape",
  },
];

export const updates = [
  {
    id: "up1",
    tag: "本周热播",
    title: "《摇曳露营△》第三季迎来富士山露营名场面",
    date: "2026-08-15",
    text: "抚子与凛终于实现富士山脚下的冬日露营，星空下煮咖喱的桥段被网友称为「年度治愈名场面」……",
    readTime: "3 分钟",
  },
  {
    id: "up2",
    tag: "片单更新",
    title: "编辑部新增「萌系治愈」专题：10 部软萌番一次收齐",
    date: "2026-08-12",
    text: "从向阳素描到兽娘动物园，编辑部把最解压的萌系治愈番整理成一份可一口气看完的清单……",
    readTime: "5 分钟",
  },
  {
    id: "up3",
    tag: "编辑推荐",
    title: "夏日炎热？推荐 5 部自带凉意的清凉日常番",
    date: "2026-08-09",
    text: "空调房里看这些透着清凉气息的日常番，心情和体感都能一起降降温……",
    readTime: "4 分钟",
  },
];

export const faqs = [
  {
    q: "小狗看番是什么？",
    a: "小狗看番是一个专注治愈系、日常系、萌系与温馨动画的内容平台。编辑部会持续整理「治愈番推荐」「日常系合集」「萌系动画片单」等主题榜单，帮你快速挑到适合放松心情、看完心里暖暖的番，追更不迷路。",
  },
  {
    q: "这里的片单多久更新一次？",
    a: "热门片单和专题合集每周更新，追更动态与番剧资讯则按新番播出节奏持续跟进。你可以在「追更动态」板块看到最新更新的片单与编辑推荐。",
  },
  {
    q: "推荐依据是什么？会不会夹带私货？",
    a: "片单综合了豆瓣评分、观众口碑与编辑部试看体验，同时会明确标注每部番的「情绪标签」与适用场景（如睡前放松、下饭欢乐、深度治愈），让你按需挑选。",
  },
  {
    q: "我喜欢的治愈番不在片单里，怎么办？",
    a: "欢迎通过下方留言表单把心头好推荐给我们，编辑部会评估收录进后续片单。也欢迎留下你的观看反馈，帮助我们把榜单做得更贴合大家的喜好。",
  },
  {
    q: "小狗看番的榜单需要付费吗？",
    a: "完全免费。所有片单、专题与追更动态均免费浏览，我们也不会用付费墙隐藏任何推荐内容。",
  },
];